import thingsToDoMap from './modules/thingsToDoMap.js';

export default {
  init() {

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // Hotel Booking Form onSubmit
    // $ ('.hotel-booking-form').submit(function(e) {
    //   if ($(this).find('input.check-in').val().toLowerCase() === '' ||
    //     $(this).find('input.check-out').val().toLowerCase() === '') {
    //     $(this).find('.date-validator').show();
    //     e.preventDefault();
    //   } else {
    //     $(this).find('.date-validator').hide();
    //   }
    // });

    thingsToDoMap();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateHotelParkingDirections.js